"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importDefault(require("react"));
const style_1 = tslib_1.__importDefault(require("../utils/style"));
const Circle = ({ number, current, previous, onClick }) => {
    const paddedNumber = number.toString().padStart(2, '0');
    const styleLocal = style_1.default();
    return (react_1.default.createElement("div", { onClick: onClick, className: styleLocal.stepCircle, style: {
            backgroundColor: current
                ? "white"
                : previous
                    ? "#005B96" // Light blue for previous steps
                    : "white",
            border: current ? "2px solid #005B96" : "0.25px solid #8F8F8F",
        } },
        react_1.default.createElement("h5", { style: {
                color: current ? "#005B96" : previous ? "white" : "#8F8F8F",
            }, className: styleLocal.stepNumber }, paddedNumber)));
};
function SubLayout(props) {
    const { data, setCurrentStepByClick, currentStep } = props;
    const handleClick = (index) => {
        return () => {
            setCurrentStepByClick(index);
        };
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "center", style: { textAlign: "center" } }, data.map((d, index) => {
        const isPrevious = index < currentStep;
        const isCurrent = index === currentStep;
        return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 3, md: 2 },
                react_1.default.createElement(core_1.Grid, { container: true, direction: "column", alignItems: "center" },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(Circle, { number: index + 1, current: isCurrent, previous: isPrevious, onClick: handleClick(index) })),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Typography, { style: {
                                fontSize: "13px",
                                paddingTop: "15px",
                                fontFamily: "Poppins, sans-serif",
                                color: isCurrent ? "#005B96" : "#8F8F8F",
                            } }, d.text)))),
            index !== data.length - 1 && (react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 1 },
                react_1.default.createElement("hr", { style: {
                        marginTop: "25px",
                        opacity: "0.32",
                    }, color: "rgba(112, 112, 112, .12)" })))));
    })));
}
exports.SubLayout = SubLayout;
//# sourceMappingURL=sub-layout.js.map